var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 0.333344C16.6293 0.333344 21.3333 5.03734 21.3333 10.8333C21.3333 16.6293 16.6293 21.3333 10.8333 21.3333C5.03734 21.3333 0.333336 16.6293 0.333336 10.8333C0.333336 5.03734 5.03734 0.333344 10.8333 0.333344ZM10.8333 19C15.3448 19 19 15.3448 19 10.8333C19 6.32184 15.3448 2.66668 10.8333 2.66668C6.32184 2.66668 2.66667 6.32184 2.66667 10.8333C2.66667 15.3448 6.32184 19 10.8333 19ZM20.7325 19.0828L24.033 22.3822L22.3822 24.033L19.0828 20.7325L20.7325 19.0828Z",
    fill: "#9F9F9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.63dbb497548099aae3057e26a600c009.svg";
export { ForwardRef as ReactComponent };